import {
  IPlaidCreateLinkTokenParams,
  IPlaidExchangeParams,
  IPlaidPromoteAccountParams,
} from '@common/interfaces/plaid'
import Base from './base'

export default class Plaid extends Base {
  createLinkToken(data: IPlaidCreateLinkTokenParams) {
    return this.apiClient.post('plaid/link-token', data)
  }

  exchangePublicToken(data: IPlaidExchangeParams) {
    return this.apiClient.post('plaid/exchange', data)
  }

  listItems(data: { clientId: string }) {
    return this.apiClient.get('plaid/items', data)
  }

  listAccounts(plaidItemId: string) {
    return this.apiClient.get(`plaid/items/${plaidItemId}/accounts`)
  }

  listAccountBalanceHistory(clientId: string) {
    return this.apiClient.get('plaid/balance-history', { clientId })
  }

  promoteAccount(plaidAccountId: string, data: IPlaidPromoteAccountParams) {
    return this.apiClient.post(`plaid/accounts/${plaidAccountId}/promote`, data)
  }

  removeItem(plaidItemId: string) {
    return this.apiClient.delete(`plaid/items/${plaidItemId}`)
  }

  manualSync(plaidItemId: string, sinceDate?: string) {
    return this.apiClient.post(`plaid/sync/${plaidItemId}`, sinceDate ? { sinceDate } : {})
  }
}
